module.exports = __webpack_public_path__ + "img/facade-3.e1fabf45.jpg";